import { makeStyles } from '@material-ui/core/styles';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  card: {
    padding: '0.75rem 1rem',
    borderRadius: '0.5rem',
    backgroundColor: neutral.white,
    border: `1px solid ${neutral[30]}`,
    '& h5': {
      marginBottom: '0.25rem',
      fontWeight: 600,
      fontSize: '0.625rem',
      lineHeight: '1rem',
      letterSpacing: '0.12rem',
      textTransform: 'uppercase',
      color: neutral[60],
    },
    '& p': {
      fontWeight: 400,
      fontSize: '0.875rem',
      lineHeight: '1.5rem',
      color: neutral[100],
    },
  },

  mainSection: {
    marginBottom: '0.5rem',
    display: 'flex',
    gap: '1rem',
    '& > div': {
      flex: 1,
    },
  },

  imageContainer: {
    marginTop: '0.75rem',
    '& > img': {
      width: '100%',
      '[data-complaint-seen="true"] &': {
        filter: 'grayscale(100%)',
      },
    },
  },
});
